import React from 'react';
import floatImage1 from '../../assets/images/float_image1.svg';
import floatImage2 from '../../assets/images/float_image2.svg';
import dashboardImage from '../../assets/images/dashboard-image.svg';

const Why: React.FC = () => {
  return (
    <div className="bg-white py-28 relative">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="  font-semibold text-gray-400 pb-6">
          WHY SPEEDYSSEY?
        </h2>
        <h3 className="special-header text-5xl md:text-6xl font-bold text-[#1A1A1A] pb-2 mt-4">
          HUMAN ACCOUNT MANAGERS
        </h3>
        <p className="mt-6 text-xl text-gray-600 max-w-xl mx-auto">
          You'll never talk to a bot. Our real logistics experts help design the right strategy for your business goals.
        </p>
        <div className="flex justify-center space-x-2 mt-8">
          <span className="w-3 h-3 bg-[#F55109] rounded-full"></span>
          <span className="w-3 h-3 bg-gray-300 rounded-full"></span>
          <span className="w-3 h-3 bg-gray-300 rounded-full"></span>
        </div>
      </div>

      <div className="mt-16 relative">
        <img
          src={floatImage1}
          alt="Floating graphic 1"
          className="absolute top-0 left-20 w-24 h-24 animate-bounce-slow"
        />
        <img
          src={floatImage2}
          alt="Floating graphic 2"
          className="absolute top-1/4 right-20 w-24 h-24 animate-bounce-slow delay-500"
        />
        <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <img
            src={dashboardImage}
            alt="Speedyssey Dashboard"
            className="w-full h-auto "
          />
        </div>
      </div>
    </div>
  );
};

export default Why;
